import {
	Table,
	TableHead,
	TableBody,
	TableRow,
	TableCell,
	Paper,
	TableContainer,
	TableFooter,
	LinearProgress,
} from "@mui/material";
import { Progress } from "../../../components/styles/styles";
import CustomPagination from "../../../components/paginate";
import libFloat from "../../../util/libFloat";
import { formatInTimeZone } from "date-fns-tz";
import functions from "../../../util/functions";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSearch } from "@fortawesome/free-solid-svg-icons";
// import EditIcon from "@mui/icons-material/Edit";
// import Loading from "../../../../components/loading";
// import CustomPagination from "../../../../components/paginate";
// import { useContext } from "react";
// import { ContextRegister } from "../context-api";

const formatCellValue = (value, formatType) => {
	if (value === null || value === undefined) return "";
	switch (formatType) {
		case "currency":
			return libFloat.strToCurrency(value);

		case "date":
			return formatInTimeZone(new Date(value), "UTC", "dd/MM/yyyy");
		// return format(new Date(value), "dd/MM/yyyy");

		case "dateTime":
			return functions.dateTimeToStrIso8601(value);

		case "badgePgto":
			return (
				<div className={`${value === "SIM" ? "badge_status bg_red" : "badge_status bg_green"}`}>
					{value === "SIM" ? "Pendente" : "Pago"}
				</div>
			);
		case "image":
			return (
				<img
					src={value}
					alt="Imagem"
					style={{ width: 50, height: 50, borderRadius: "5px", objectFit: "cover" }}
					onError={(e) => (e.target.src = "/fallback-image.png")} // Caso a imagem não carregue
				/>
			);
		case "banner":
			return (
				<img
					src={value}
					alt="Imagem"
					style={{ width: 130, height: 50, borderRadius: "5px", objectFit: "cover" }}
					onError={(e) => (e.target.src = "/fallback-image.png")} // Caso a imagem não carregue
				/>
			);

		default:
			return value;
	}
};

const itemsPerPage = 15; // Quantidade de itens por página

function TableMain({
	searchedData,
	tableColumns,
	isLoading,
	page,
	setPage,
	totalPage,
	currentPage,
	nextFetch,
	setSelectData,
	handleOpenModalAux,
}) {
	// const { options1, setSelectData, searchedData, nextFetch, page, setPage, totalPage, currentPage, loading } =
	// 	useContext(ContextRegister);

	const handleChangePage = (event, newPage) => {
		if (newPage > currentPage.current && totalPage === 0) {
			nextFetch(newPage);
		}
		setPage(newPage);
	};

	// const handleClickEdit = (item) => {
	// 	//passa para o contexto o item selecionado que fica disponivel para o form
	// 	setSelectData(item);
	// 	handleOpenModalRegister();
	// 	// handleOpenModalRegister(item);
	// };

	const startIndex = (page - 1) * itemsPerPage;
	const endIndex = startIndex + itemsPerPage;
	const slicedData = searchedData.slice(startIndex, endIndex);

	const handleAction = (item) => {
		setSelectData(item);
		handleOpenModalAux();
	};

	return (
		// <Paper>
		<TableContainer component={Paper}>
			<Table>
				<TableHead className="color-table">
					<TableRow>
						{tableColumns.map((column) => (
							<TableCell key={column.key} align={column.align}>
								<span className="text-color-table">{column.label}</span>
							</TableCell>
						))}
					</TableRow>
				</TableHead>
				<TableBody>
					{slicedData.map((item, key) => {
						const rowKey = key; //item.id_complementos_grupo; // Certifique-se de que esse valor é único

						return (
							<TableRow key={rowKey} className="zebra-row">
								{tableColumns.map((column) => {
									const cellKey = `${rowKey}-${column.key}`; // Garantir chave única

									return (
										<TableCell key={cellKey} align={column.align}>
											{column.key.startsWith("action") ? (
												<button
													className="btn btn-sm btn-outline-primary flex items-center justify-center p-1"
													onClick={() => handleAction(item)}
												>
													<FontAwesomeIcon icon={faSearch} size="lg" />
												</button>
											) : column.key === "perc" ? (
												<Progress
													width={item.perc + item.perc / 2}
													color="blue"
													style={{ display: "inline-block" }}
												>
													<small>{item.perc}%</small>
													<div className="progressListBackground">
														<div className="progressList"></div>
													</div>
												</Progress>
											) : (
												formatCellValue(item[column.key], column.format) || ""
											)}
										</TableCell>
									);
								})}
							</TableRow>
						);
					})}
				</TableBody>

				{isLoading ? (
					<TableFooter>
						<TableRow>
							<TableCell colSpan={tableColumns.length}>
								<LinearProgress variant="indeterminate" />
							</TableCell>
						</TableRow>
					</TableFooter>
				) : (
					searchedData.length === 0 && (
						<TableBody>
							<TableRow>
								<TableCell colSpan={tableColumns.length} className="italic text-gray-400">
									Nenhum registro encontrado.
								</TableCell>
							</TableRow>
						</TableBody>
					)
				)}
			</Table>

			{/* {loading && (
				<div className="flex h-44">
					<Loading mensagem="Carregando dados dos produtos" />
				</div>
			)} */}

			{searchedData?.length > 0 && (
				<CustomPagination
					count={Math.ceil(searchedData.length / itemsPerPage)}
					page={page}
					onChangePage={handleChangePage}
					totalRecord={searchedData.length}
					totalPage={totalPage}
				/>
			)}
			{/* // </Paper> */}
		</TableContainer>
	);
}

export default TableMain;
